export default "__VITE_ASSET__RmVOo_lF__"